import React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from '../StyledModal';

import EnterSend from "../EnterSend";

import { NotificationManager } from 'react-notifications';

import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';

function MyModalModifUser({IsModalOpened, onCloseModal, userInfo, getInfoUser, indexSelected}) {

	const [idUser, setIdUser] = React.useState('');
	const [idCompte, setIdCompte] = React.useState('');
	const [deviceName1, setDeviceName1] = React.useState('');
	const [deviceName2, setDeviceName2] = React.useState('');
	const [macAdress1, setMacAdress1] = React.useState('');
	const [macAdress2, setMacAdress2] = React.useState('');
	const [pseudo, setPseudo] = React.useState('');
	const [avatar, setAvatar] = React.useState('');
	const [codeSecret, setCodeSecret] = React.useState('');

	const handleSubmit = () => {
		if(IsModalOpened === true) {
			modifUser()
		}
	}

	function onModalClose(event) {
		onCloseModal(event, 4);
	}

		React.useEffect(() => {
			const selectedUser = Array.isArray(userInfo) ? userInfo[indexSelected] : undefined;
			if(IsModalOpened === true && selectedUser) {
				setIdCompte(selectedUser.id_compte || '')
				setIdUser(selectedUser.id_user || '')
				setCodeSecret(selectedUser.pin_code || '')
				setDeviceName1(selectedUser.device_name_1 || '')
				setDeviceName2(selectedUser.device_name_2 || '')
				setMacAdress1(selectedUser.mac_adress_1 || '')
				setMacAdress2(selectedUser.mac_adress_2 || '')
				setAvatar(selectedUser.id_avatar || '')
				setPseudo(selectedUser.pseudo || '')
			}
		}, [IsModalOpened, indexSelected, userInfo]);

	function modifUser() {
		const normalizedDeviceName1 = deviceName1.trim();
		const normalizedDeviceName2 = deviceName2.trim();
		const normalizedMacAdress1 = macAdress1.trim();
		const normalizedMacAdress2 = macAdress2.trim();
		const device1IsComplete = Boolean(normalizedDeviceName1) === Boolean(normalizedMacAdress1);
		const device2IsComplete = Boolean(normalizedDeviceName2) === Boolean(normalizedMacAdress2);

		if (!device1IsComplete || !device2IsComplete) {
			NotificationManager.error('Le nom et l’adresse MAC d’un appareil doivent être renseignés ou supprimés ensemble.', '', 4000);
			return;
		}

		if(pseudo !== '' && codeSecret !== '') {
			const formData = new FormData();

			formData.append('id_compte', idCompte)
			formData.append('id_user', idUser)
			formData.append('new_pin_code', codeSecret)
			formData.append('mac_adress_1', normalizedMacAdress1 === '' ? null : normalizedMacAdress1)
			formData.append('mac_adress_2', normalizedMacAdress2 === '' ? null : normalizedMacAdress2)
			formData.append('device_name_1', normalizedDeviceName1 === '' ? null : normalizedDeviceName1)
			formData.append('device_name_2', normalizedDeviceName2 === '' ? null : normalizedDeviceName2)
			formData.append('id_avatar', avatar)
			formData.append('pseudo', pseudo)

			axios.post('https://eps.acces-editions.com/api/updateAllUserInfo', formData)
			.then((res) => {
			  if(res.status === 200)
			  {
			    NotificationManager.success('Utilisateur modifié', '', 3000);
			    onModalClose(true)
			    getInfoUser(idCompte)
			  } else {
			    NotificationManager.error('Une erreur s\'est produite', '', 3000);
			  }
			})
		} else {
		  NotificationManager.error('Erreur saisie dans les champs', '', 3000);
		}
	}

	return (
	  <>
	    <Modal size="md" active={IsModalOpened} toggler={() => {return}}>
	      <ModalHeader toggler={() => onModalClose(false)}>
	          Modifier utilisateur
	      </ModalHeader>
	      <ModalBody>
	        <div style={{ textAlign: 'center' }}>
	          <div className="mb-6 grid grid-cols-2 gap-4">
	            <div className="col-span-2 text-left">
	              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="edit-user-pseudo">Pseudo</label>
	              <input id="edit-user-pseudo" className="w-full border border-inherit p-2 rounded" value={pseudo} type="text" onChange={(e) => setPseudo(e.target.value) }/>
	            </div>
	            <div className="col-span-2 text-left">
	              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="edit-user-pin">Code secret</label>
	              <input id="edit-user-pin" className="w-full border border-inherit p-2 rounded" value={codeSecret} type="text" onChange={(e) => setCodeSecret(e.target.value) }/>
	            </div>
	            <fieldset className="col-span-2 ae-admin-device-editor">
	              <legend>Appareil 1</legend>
	              <div className="text-left">
	                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="edit-user-device-1">Nom de l’appareil</label>
	                <input id="edit-user-device-1" className="w-full border border-inherit p-2 rounded" value={deviceName1} type="text" onChange={(e) => setDeviceName1(e.target.value) }/>
	              </div>
	              <div className="text-left">
	                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="edit-user-mac-1">Adresse MAC</label>
	                <input id="edit-user-mac-1" className="w-full border border-inherit p-2 rounded" value={macAdress1} type="text" onChange={(e) => setMacAdress1(e.target.value) }/>
	              </div>
	              <button className="ae-admin-device-clear" type="button" disabled={!deviceName1 && !macAdress1} onClick={() => { setDeviceName1(''); setMacAdress1(''); }}>
	                <FontAwesomeIcon icon={faTrashCan} />
	                <span>Supprimer l’appareil 1</span>
	              </button>
	            </fieldset>
	            <fieldset className="col-span-2 ae-admin-device-editor">
	              <legend>Appareil 2</legend>
	              <div className="text-left">
	                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="edit-user-device-2">Nom de l’appareil</label>
	                <input id="edit-user-device-2" className="w-full border border-inherit p-2 rounded" value={deviceName2} type="text" onChange={(e) => setDeviceName2(e.target.value) }/>
	              </div>
	              <div className="text-left">
	                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="edit-user-mac-2">Adresse MAC</label>
	                <input id="edit-user-mac-2" className="w-full border border-inherit p-2 rounded" value={macAdress2} type="text" onChange={(e) => setMacAdress2(e.target.value) }/>
	              </div>
	              <button className="ae-admin-device-clear" type="button" disabled={!deviceName2 && !macAdress2} onClick={() => { setDeviceName2(''); setMacAdress2(''); }}>
	                <FontAwesomeIcon icon={faTrashCan} />
	                <span>Supprimer l’appareil 2</span>
	              </button>
	            </fieldset>
	          </div>
	        </div>
	      </ModalBody>
	      <ModalFooter>
	          <Button 
	              color="red"
	              buttonType="link"
	              onClick={(e) => onModalClose(false)}
	              ripple="dark"
	          >
	            Fermer
	          </Button>
	          <Button
	              color="green"
	              onClick={(e) => modifUser()}
	              ripple="light"
	          >
	            <EnterSend handleSubmit={handleSubmit}/>
	            Valider
	          </Button>
	      </ModalFooter>
	    </Modal>
	  </>
	);
}

export default MyModalModifUser;
